/* eslint-disable react/function-component-definition */
import React from 'react'
var styles = {
  ganttTable: '_3_ygE',
  ganttTable_Header: '_1nBOt',
  ganttTable_HeaderSeparator: '_2eZzQ',
  ganttTable_HeaderItem: '_WuQ0f',
}
const TaskListHeader = function TaskListHeader(_ref) {
  var headerTitle = _ref.headerTitle || '\xA0Sections & Tasks'
  var headerHeight = _ref.headerHeight,
    fontFamily = _ref.fontFamily,
    fontSize = _ref.fontSize,
    rowWidth = _ref.rowWidth
  return React.createElement(
    'div',
    {
      className: styles.ganttTable,
      style: {
        fontFamily: fontFamily,
        fontSize: fontSize,
      },
    },
    React.createElement(
      'div',
      {
        className: styles.ganttTable_Header,
        style: {
          height: headerHeight - 2,
        },
      },
      React.createElement(
        'div',
        {
          className: styles.ganttTable_HeaderItem,
          style: {
            minWidth: rowWidth,
          },
        },
        headerTitle
      ),
      React.createElement('div', {
        className: styles.ganttTable_HeaderSeparator,
        style: {
          height: headerHeight * 0.5,
          marginTop: headerHeight * 0.2,
        },
      })
    )
  )
}

export default TaskListHeader
